import { render, staticRenderFns } from "./RelativeRelationTypeCards.vue?vue&type=template&id=04dea009&"
import script from "./RelativeRelationTypeCards.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports